export default __webpack_public_path__ + "static/media/chatbot2.a7a1940b.svg";